const $ = jQuery;

$(document).bind('gform_page_loaded', function(event, form_id) {
    if ($('#input_' + form_id + '_6_3').length === 0) {
        return;
    }
    $('span.first_name').html(jQuery('#input_' + form_id + '_6_3').val());
});

$(document).ready(function($) {
	// Initialize FitVids
	$('iframe[src*="youtube"],iframe[src*="youtu.be"],iframe[src*="vimeo"]').parent().fitVids({ maxWidth: 1024 });

    // Landing page form
    if (window.location.hash === '#take-survey') {
        $('.take-survey-modal').addClass('active');
    }
    $('.take-survey').click(function(e) {
        e.preventDefault();
        $('.take-survey-modal').addClass('active');
    });
    $('.take-survey-modal .close-button').click(function(e) {
        e.preventDefault();
        $('.take-survey-modal').removeClass('active');
    });

	// Quotes Slider
	$('.quotes-slider').slick({
		arrows: false,
		slidesToShow: 1,
		slidesToScroll: 1,
    });
    $('.quotes-slider-control .slider-prev').click(function(e) {
        e.preventDefault();
        $('.quotes-slider').slick('prev');
    });
    $('.quotes-slider-control .slider-next').click(function(e) {
        e.preventDefault();
        $('.quotes-slider').slick('next');
    });

	// Quick Facts Slider
	$('.quick-fact-slider').slick({
		arrows: false,
		slidesToShow: 1,
		slidesToScroll: 1,
	});
    $('.quick-fact-slider-control .slider-prev').click(function(e) {
        e.preventDefault();
        $('.quick-fact-slider').slick('prev');
    });
    $('.quick-fact-slider-control .slider-next').click(function(e) {
        e.preventDefault();
        $('.quick-fact-slider').slick('next');
    });

    // Vendors slider
	$('.section-vendors-slider .vendors-list').slick({
        slide: 'div',
        arrows: false,
		slidesToShow: 3,
		slidesToScroll: 3,
    });
    $('.vendors-slider-control .slider-prev').click(function(e) {
        e.preventDefault();
        $('.section-vendors-slider .vendors-list').slick('prev');
    });
    $('.vendors-slider-control .slider-next').click(function(e) {
        e.preventDefault();
        $('.section-vendors-slider .vendors-list').slick('next');
    });
});

// Navigation
$(document).ready(function() {
    var menuToggle = $("#js-mobile-menu").unbind();

    menuToggle.on("click", function(e) {
        e.preventDefault();
        $("#js-navigation-menu").slideToggle(function() {
            if ($("#js-navigation-menu").is(":hidden")) {
                $("#js-navigation-menu").removeAttr("style");
            }
        });
    });
});

// Sliding panel
$(document).ready(function(){
    $('.sliding-panel-button,.sliding-panel-fade-screen,.sliding-panel-close').on('click touchstart', function(e) {
        $('.sliding-panel-content,.sliding-panel-fade-screen').toggleClass('is-visible');
        e.preventDefault();
    });
});



// WEBPACK FOOTER //
// ./src/js/common.js